$(document).ready(function() {
$('.new-mobile__menu li.submneu > a').click(function(event) {
    event.preventDefault();
    
    var $parent = $(this).parent('.submneu');
    var $subMenu = $parent.find('.submenu__wrapper'); // Use find to locate submenu

    // Check if the clicked submenu is already active
    if ($parent.hasClass('active')) {
        // Remove the active class and smoothly slide up the submenu
        $parent.removeClass('active');
        $subMenu.stop().slideUp(400);
    } else {
        // Remove active class from all submenus and smoothly hide others
        $('.submneu').removeClass('active');
        $('.submenu__wrapper').stop().slideUp(400);

        // Add active class to the clicked submenu and smoothly slide it down
        $parent.addClass('active');
        $subMenu.stop().slideDown(400);
    }
});

  
    $('.featured-collections .product-item .remove-line-height-space--small').matchHeight();
  
});

$(window).resize(function() {
    $('.featured-collections .product-item .remove-line-height-space--small').matchHeight();
});

$(document).ready(function() {
  // $('.featured-collections .product-item .remove-line-height-space--small').matchHeight();

  
  
  function initializeSlick() {
    if ($(window).width() < 768) {
      if (!$('.js-featured-collection .grid.grid--layout').hasClass('slick-initialized')) {
        $('.js-featured-collection .grid.grid--layout').slick({
          slidesToShow: 2,
          infinite: false,
          slidesToScroll: 2,
          autoplay: false,
          autoplaySpeed: 2000,
          arrows: true,
          dots: true,
          swipe: true,
          prevArrow: '<button class="slick-prev slick-arrow"><svg width="10" height="17" viewBox="0 0 10 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path opacity="1" d="M8.5 2L2 9.22222L8.5 15" stroke="black" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
          nextArrow: '<button class="slick-next slick-arrow"><svg width="11" height="17" viewBox="0 0 11 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.27783 2L8.77783 9.22222L2.27783 15" stroke="black" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
          appendArrows: ".slick-custom__arrows",
          appendDots: ".slick-custom__dots",
        });
      }
    } else {
      if ($('.js-featured-collection .grid.grid--layout').hasClass('slick-initialized')) {
        $('.js-featured-collection .grid.grid--layout').slick('unslick');
      }
    }
  }
  function NewArrialsslider() {
    if ($(window).width() < 768) {
      if (!$('.custom-new-arrivel .grid.grid--layout').hasClass('slick-initialized')) {
        $('.custom-new-arrivel .grid.grid--layout').slick({
          slidesToShow: 2,
          infinite: false,
          slidesToScroll: 2,
          autoplay: false,
          autoplaySpeed: 2000,
          arrows: true,
          dots: true,
          swipe: true,
          prevArrow: '<button class="slick-prev slick-arrow"><svg width="10" height="17" viewBox="0 0 10 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path opacity="1" d="M8.5 2L2 9.22222L8.5 15" stroke="black" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
          nextArrow: '<button class="slick-next slick-arrow"><svg width="11" height="17" viewBox="0 0 11 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.27783 2L8.77783 9.22222L2.27783 15" stroke="black" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
          appendArrows: ".slick-customs__arrows",
          appendDots: ".slick-customs__dots",
        });
      }
    } else {
      if ($('.custom-new-arrivel .grid.grid--layout').hasClass('slick-initialized')) {
        $('.custom-new-arrivel .grid.grid--layout').slick('unslick');
      }
    }
  }
  function discountproductslider() {
    if ($(window).width() < 768) {
      if (!$('.js-discount-product .grid.grid--layout').hasClass('slick-initialized')) {
        $('.js-discount-product .grid.grid--layout').slick({
          slidesToShow: 2,
          infinite: false,
          slidesToScroll: 2,
          autoplay: false,
          autoplaySpeed: 2000,
          arrows: true,
          dots: true,
          swipe: true,
          prevArrow: '<button class="slick-prev slick-arrow"><svg width="10" height="17" viewBox="0 0 10 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path opacity="1" d="M8.5 2L2 9.22222L8.5 15" stroke="black" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
          nextArrow: '<button class="slick-next slick-arrow"><svg width="11" height="17" viewBox="0 0 11 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.27783 2L8.77783 9.22222L2.27783 15" stroke="black" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
          appendArrows: ".new-discount__arrow",
          appendDots: ".new-discount__dots",
        });
      }
    } else {
      if ($('.js-discount-product .grid.grid--layout').hasClass('slick-initialized')) {
        $('.js-discount-product .grid.grid--layout').slick('unslick');
      }
    }
  }
  function blogslider() {
    if ($(window).width() < 768) {
      if (!$('.js-blog-slider .grid.grid--layout').hasClass('slick-initialized')) {
        $('.js-blog-slider .grid.grid--layout').slick({
          slidesToShow: 1.10,
          infinite: false,
          slidesToScroll: 1,
          autoplay: false,
          autoplaySpeed: 2000,
          arrows: true,
          dots: true,
          swipe: true,
          prevArrow: '<button class="slick-prev slick-arrow"><svg width="10" height="17" viewBox="0 0 10 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path opacity="1" d="M8.5 2L2 9.22222L8.5 15" stroke="black" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
          nextArrow: '<button class="slick-next slick-arrow"><svg width="11" height="17" viewBox="0 0 11 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.27783 2L8.77783 9.22222L2.27783 15" stroke="black" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
          appendArrows: ".blog-custom__arrow",
          appendDots: ".blog-custom__dots",
        });
      }
    } else {
      if ($('.js-blog-slider .grid.grid--layout').hasClass('slick-initialized')) {
        $('.js-blog-slider .grid.grid--layout').slick('unslick');
      }
    }
  }

  // Initialize slick on page load
  initializeSlick();
  NewArrialsslider();
  discountproductslider();
  blogslider()

  // Re-initialize slick on window resize
  $(window).on('resize', function() {
    initializeSlick();
    NewArrialsslider();
    discountproductslider();
    blogslider()
  });
});


$(document).ready(function(){
  $('.menu-toggle__icon svg').click(function(){
     $('.new-mobile__menu').addClass('mobile-menu__open');
     $('body').addClass('mobile-menu__open');
  });
  $('.mobile-menu__close-icon svg').click(function(){
     $('.new-mobile__menu').removeClass('mobile-menu__open');
     $('body').removeClass('mobile-menu__open');
  });

});


document.addEventListener('DOMContentLoaded', function () {
    // Function to match the height of all .product-item__title elements to the tallest one
    function matchTitleHeights() {
        // Get all the title elements within the grid
        const titles = document.querySelectorAll('#CollectionProductGrid .product-item__title');
        
        if (titles.length === 0) {
            console.log('No product titles found.');
            return; // If no titles are found, do nothing
        }
        
        let maxHeight = 0;
        
        // Reset the heights before recalculating (in case they were previously set)
        titles.forEach(title => {
            title.style.height = ''; // Remove any inline height previously set
        });

        // Find the maximum height
        titles.forEach(title => {
            const titleHeight = title.offsetHeight; // Get the current height of the title
            
            // Update maxHeight if this title is taller than the current maxHeight
            if (titleHeight > maxHeight) {
                maxHeight = titleHeight;
            }
        });
        
        // Set all titles to have the same height as the tallest one
        titles.forEach(title => {
            title.style.height = `${maxHeight}px`;
        });
    }

    // Run the function when the page is loaded
    matchTitleHeights();

    // Optionally, run the function when the window is resized
    window.addEventListener('resize', matchTitleHeights);
});

document.addEventListener("DOMContentLoaded", function() {
    // Get all elements with the class 'product-price' inside '#CollectionProductGrid'
    const productPrices = document.querySelectorAll("#CollectionProductGrid .product-price");

    if (productPrices.length > 0) {
        let maxHeight = 0;

        // Loop through all product-price elements to find the max height
        productPrices.forEach(function(productPrice) {
            const height = productPrice.offsetHeight;
            if (height > maxHeight) {
                maxHeight = height;
            }
        });

        // Set the max height for all product-price elements
        productPrices.forEach(function(productPrice) {
            productPrice.style.height = `${maxHeight}px`;
        });
    }
});


// Select the parent element
var parentElement = document.querySelector('.shopify-section.cust-rpc-sec');

// Check if the parent element has a child with the class '.cust-container'
if (parentElement && parentElement.querySelector('.cust-container')) {
    // If it has the child, show the parent element
    parentElement.style.display = 'block';
} else {
    // If it doesn't have the child, hide the parent element
    parentElement.style.display = 'none';
}

var parentElement = document.querySelector('.shopify-section.product-360-view');

// Check if the parent element has a child with the class '.cust-container'
if (parentElement && parentElement.querySelector('product-model')) {
    // If it has the child, show the parent element
    parentElement.style.display = 'block';
} else {
    // If it doesn't have the child, hide the parent element
    parentElement.style.display = 'none';
}



$( document ).ready(function() {
chatinterval = setInterval(function(){
    var slider = $('product-recommendations .grid').length;
  //  console.log(slider);
    if(slider == 1){
    //   console.log("Apply Slider");
        if ($(window).width() < 768) {
      if (!$('product-recommendations .grid').hasClass('slick-initialized')) {
        $('product-recommendations .grid').slick({
          slidesToShow: 2,
          infinite: false,
          slidesToScroll: 2,
          autoplay: false,
          autoplaySpeed: 2000,
          arrows: true,
          dots: true,
          swipe: true,
          prevArrow: '<button class="slick-prev slick-arrow"><svg width="10" height="17" viewBox="0 0 10 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path opacity="1" d="M8.5 2L2 9.22222L8.5 15" stroke="black" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
          nextArrow: '<button class="slick-next slick-arrow"><svg width="11" height="17" viewBox="0 0 11 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.27783 2L8.77783 9.22222L2.27783 15" stroke="black" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
          appendArrows: ".slick-customs__arrows",
          appendDots: ".slick-customs__dots",
        });
      }
    } else {
      if ($('product-recommendations .grid').hasClass('slick-initialized')) {
        $('product-recommendations .grid').slick('unslick');
      }
    }
       clearInterval(chatinterval);
    }else{
     //  console.log("Not Get Product Div");
    }
}, 1000);
});